$.widget("ui.dialog", $.ui.dialog, {
  /*! jQuery UI - v1.11.4 - 2015-06-05
   *  http://bugs.jqueryui.com/ticket/9087#comment:27 - bugfix
   *  http://bugs.jqueryui.com/ticket/4727#comment:23 - bugfix
   *  allowInteraction fix to accommodate windowed editors
   */
  _allowInteraction: function (event) {
    if (this._super(event)) {
      return true;
    }

    // address interaction issues with dialog window
    if ($(event.target).closest(".ck").length) {
      return true;
    }

    return false;
  },
});

class EasyDialog {
  $dialog;

  constructor(id) {
    this.id = `#${id || "ajax-modal"}`;
    this.$el = $(this.id);
    this.mh = ERUI.topMenu.outerHeight();
    this.wh = window.innerHeight;
  }

  /**
   * Default attributes of modal dialog
   * @return {Object}
   */
  get defaults() {
    return {
      id: "#ajax-modal",
      width: "90%",
      maxHeight: this.wh - this.mh - 20,
    };
  }

  /**
   * Open dialog modal
   * @param width {String, null} (80%) set modal width
   * @param title {String, null} modal title, by default it try to use text of H3.title element
   * @param minHeight {String, null}
   * @param maxHeight {String, null}
   * @return {Object}
   */
  show(width, title, minHeight, maxHeight) {
    if (!title) title = this.$el.find("h3.title").text();
    this.$dialog = this.$el.dialog({
      width: this.defaults.width,
      modal: true,
      resizable: false,
      dialogClass: "modal",
      maxHeight: this.parseHeight(maxHeight) || this.defaults.maxHeight,
      maxWidth: "100%",
      minHeight: this.parseHeight(minHeight),
      title: title,
      position: { my: "top", at: "top" },
      open: (_event, _ui) => {
        // @see https://api.jqueryui.com/dialog/#event-open
        ERUI.body.addClass("modal-opened");
        window.initEasyAutocomplete();
        const listOfToggles = document.querySelectorAll(`${this.id} *[data-toggle]`);
        listOfToggles.forEach(window.EasyToggler.ensureToggleItem);
        displayTabsButtons();
        EASY.utils.modalOpened = true;
        this.hideVueModal();
      },
      close: (_event, _ui) => {
        // @see https://api.jqueryui.com/dialog/#event-close
        ERUI.body.removeClass("modal-opened");
        this.$dialog.dialog("destroy");
        EASY.utils.modalOpened = false;
        this.showVueModal();
      },
    });
    $(this.defaults.id).trigger("erui_interface_change_modal");
  }

  resize(width, minHeight, maxHeight) {
    this.$el.dialog({
      width: width || this.defaults.width,
      maxHeight: this.parseHeight(maxHeight) || this.defaults.maxHeight,
      minHeight: this.parseHeight(minHeight),
    });
    $(this.defaults.id).trigger("erui_interface_change_modal");
  }

  /**
   * Parse height given by string to magical dialog height
   * @param height {String, Number, null}
   * @return {Number}
   */
  parseHeight(height) {
    if (typeof height === "string") {
      return (this.defaults.maxHeight * parseInt(height)) / 100;
    } else {
      return height;
    }
  }

  /**
   * @todo REFACTOR ME
   *
   * Update / ajdust current modal height according buttons section
   * @param $el {Object} - jquery dialog
   * @param $btns {Object} - jquery array?
   * @return {Number}
   */
  recalculateHeight($el, $btns) {
    const btnsHeight = $btns ? $btns.outerHeight() : 0;
    const posBottom = 158;
    const maxHeight = this.wh - this.mh - btnsHeight - posBottom;
    // hack instead of not functional $el.dialog({maxHeight: 'value'})
    $el.css("max-height", maxHeight);

    return maxHeight;
  }

  hide() {
    this.$el.dialog("close");
  }

  /**
   * Just alias
   */
  close() {
    this.hide();
  }

  hideVueModal() {
    const vueModal = this.getVueModal();
    const hasVueModalContent = this.hasVueModalContent(vueModal);
    if (hasVueModalContent) {
      vueModal.style.display = "none";
    }
  }

  showVueModal() {
    const vueModal = this.getVueModal();
    if (vueModal) vueModal.style.display = "block";
  }

  hasVueModalContent(vueModal) {
    if (!vueModal) return false;
    const allDescendants = vueModal.querySelectorAll("*");
    return allDescendants.length > 1;
  }

  getVueModal() {
    return document.querySelector("#modal-app-wrapper");
  }
}

// === LEGACY bypass

window.showModal = function (id, width, title, minHeight, maxHeight) {
  const dialog = new EasyDialog(id);
  return dialog.show(width, title, minHeight, maxHeight);
};

window.resizeModal = function (id, width, minHeight, maxHeight) {
  const dialog = new EasyDialog(id);
  return dialog.resize(width, minHeight, maxHeight);
};

// @note: It seems its something just for mobile. I am not sure if it works...
window.recalculateModalHeight = function ($el, $btns) {
  const dialog = new EasyDialog();
  dialog.recalculateHeight($el, $btns);
};

window.hideModal = function (el) {
  if (el) {
    const modal = $(el).parents(".ui-dialog-content");
    modal.dialog("close");
  } else {
    const dialog = new EasyDialog("ajax-modal");
    dialog.hide();
  }
};
